import {IFormArr} from '@/components/types'
import {useSearchDateShortcut} from "@/hooks/useSearch";
const shortcuts = useSearchDateShortcut()

export const basicFormConfig: IFormArr = {
  labelWidth: '180px',
  iForms: [
    {
      formItems: [
        {
          label: '活动名称',
          field: 'raffleName',
          type: 'input',
          placeholder: '请输入活动名称'
        },
        {
          field: 'consumePointTimeSlot',
          type: 'datepicker',
          label: '消耗积分的所属时间',
          otherOptions: {
            startPlaceholder: '开始时间',
            endPlaceholder: '结束时间',
            type: 'daterange',
            'value-format': 'YYYY-MM-DD',
            disabledDate: (date: Date) => {
              return new Date() < date
            },
            shortcuts: shortcuts
          }
        }
      ]
    },
    {
      formItems: [
        {
          label: '惊喜奖红包金额（元）',
          field: 'specialAmount',
          type: 'number',
          placeholder: '请输入惊喜奖红包金额'
        },
        {
          label: '惊喜奖红包数量（个）',
          field: 'specialNum',
          type: 'number',
          placeholder: '请输入惊喜奖红包数量'
        }
      ]
    },
    {
      formItems: [
        {
          label: '手气红包最小金额（元）',
          field: 'commonMinAmount',
          type: 'number',
          placeholder: '请输入手气红包最小金额'
        },
        {
          label: '手气红包最大金额（元）',
          field: 'commonMaxAmount',
          type: 'number',
          placeholder: '请输入手气红包最大金额'
        },
      ]
    },
    {
      formItems: [
        {
          label: '手气红包数量（个）',
          field: 'commonNum',
          type: 'number',
          placeholder: '请输入手气红包数量'
        },
        {
          label: '手气红包总金额（元）',
          field: 'commonTotalAmount',
          type: 'number',
          placeholder: '请输入手气红包总金额'
        },
      ]
    },
    {
      formItems: [
        {
          label: '开始时间',
          field: 'startTime',
          type: 'datepicker',
          otherOptions: {
            placeholder: '选择开始时间',
            type: 'datetime',
            'value-format': 'YYYY-MM-DD HH:mm:ss'
          }
        },
        {
          label: '结束时间',
          field: 'endTime',
          type: 'datepicker',
          otherOptions: {
            placeholder: '选择结束时间',
            type: 'datetime',
            'value-format': 'YYYY-MM-DD HH:mm:ss'
          }
        },
      ]
    },
    {
      formItems: [
        {
          label: '每次消耗积分',
          field: 'consumePoint',
          type: 'number',
          placeholder: '请输入每次消耗积分'
        }
      ]
    }
  ]
}
